import get from 'lodash/get';
import * as types from '../actionTypes/MissingPointsActionsTypes';

export default function MissingPointsReducer(state = {}, action = {}) {
    switch (action.type) {
        case types.ACCOUNT_CLEAR_MISSING_POINTS: {
            const missingPoints = {};
            return { ...missingPoints };
        }

        case types.ACCOUNT_POST_MISSING_POINTS: {
            const missingPoints = {};
            missingPoints.isLoading = true;
            return { ...state, ...missingPoints };
        }

        case types.ACCOUNT_POST_MISSING_POINTS_SUCCESS: {
            const missingPoints = action.missingData;
            missingPoints.isLoading = false;
            const dataErrorCode = get(missingPoints, 'data.errorCode', '');

            if (dataErrorCode) {
                missingPoints.messageInput = get(
                    action.missingData,
                    `errorScenarios.${dataErrorCode}`,
                    missingPoints.errorScenarios.SRV_GENERIC_ERROR
                );
            }
            return { ...state, ...missingPoints };
        }

        case types.ACCOUNT_POST_MISSING_POINTS_ERROR: {
            const missingPoints = action.error;
            missingPoints.isLoading = false;
            return { ...state, ...missingPoints };
        }
        default:
            return state;
    }
}
